export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "suggestions": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You may also like"])}
        }
      },
      "de": {
        "suggestions": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Das könnte Ihnen auch gefallen"])}
        }
      }
    }
  })
}